<template>
    <div class="planejamento-renderer">
        <!-- Creche -->
        <div v-if="tipo === 'creche'">
            <c-panel title="Educação Infantil — Creche">
                <el-form label-position="top">
                    <el-form-item label="Objetivos de aprendizagem">
                        <el-input type="textarea" :value="dados.objetivos_aprendizagem" readonly />
                    </el-form-item>

                    <el-form-item label="Campos de experiência">
                        <el-checkbox-group :value="dados.campos_experiencia || []" disabled>
                            <el-checkbox v-for="opt in CAMPOS_EXPERIENCIA" :key="opt.key" :label="opt.key">{{ opt.label }}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                    <el-form-item label="Atividades prioritárias">
                        <el-checkbox-group :value="dados.atividades_prioritarias || []" disabled>
                            <el-checkbox v-for="opt in ATIVIDADES_PRIORITARIAS_CRECHE" :key="opt.key" :label="opt.key">{{ opt.label }}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                    <h4 class="titulo-bloco">Momentos da rotina</h4>

                    <el-form-item label="Atividades de acolhimento">
                        <el-checkbox-group :value="dados.rotina && Array.isArray(dados.rotina.acolhimento) ? dados.rotina.acolhimento : []" disabled>
                            <el-checkbox v-for="opt in ATIVIDADES_ACOLHIMENTO_CRECHE" :key="opt.key" :label="opt.key">{{ opt.label }}</el-checkbox>
                        </el-checkbox-group>
                        <el-input 
                            v-if="dados.rotina && Array.isArray(dados.rotina.acolhimento) && dados.rotina.acolhimento.includes('outra')" 
                            class="u-mt-10" 
                            type="textarea"                             
                            :value="dados.rotina.acolhimento_outra" 
                            readonly 
                            placeholder="Outra atividade de acolhimento" 
                        />
                    </el-form-item>

                    <el-form-item label="Atividades permanentes">
                        <el-checkbox-group :value="dados.rotina && Array.isArray(dados.rotina.permanentes) ? dados.rotina.permanentes : []" disabled>
                            <el-checkbox v-for="opt in ATIVIDADES_PERMANENTES_CRECHE" :key="opt.key" :label="opt.key">{{ opt.label }}</el-checkbox>
                        </el-checkbox-group>
                        <el-input 
                            v-if="dados.rotina && Array.isArray(dados.rotina.permanentes) && dados.rotina.permanentes.includes('outra')" 
                            class="u-mt-10" 
                            type="textarea"                            
                            :value="dados.rotina.permanentes_outra" 
                            readonly 
                            placeholder="Outra atividade permanente" 
                        />
                    </el-form-item>

                    <el-form-item label="Atividades de leitura e/ou contação de histórias">
                        <el-input type="textarea" :value="dados.rotina && dados.rotina.leitura_contacao" readonly />
                    </el-form-item>

                    <el-form-item label="Brincadeiras">
                        <el-input type="textarea" :value="dados.rotina && dados.rotina.brincadeiras" readonly />
                    </el-form-item>

                    <el-form-item label="Musicalização">
                        <el-input type="textarea" :value="dados.rotina && dados.rotina.musicalizacao" readonly />
                    </el-form-item>

                    <el-form-item label="Atividade de projeto específico da Educação Infantil ou projeto didático">
                        <el-input type="textarea" :value="dados.rotina && dados.rotina.set_brasil" readonly />
                    </el-form-item>

                    <el-form-item label="Estratégias de inclusão e equidade (Adaptações, mediações, apoio individual, atenção às singularidades)">
                        <el-input type="textarea" :value="dados.rotina && dados.rotina.inclusao_equidade" readonly />
                    </el-form-item>

                    <el-form-item label="Atividades de Registro feito pelas crianças">
                        <el-input type="textarea" :value="dados.rotina && dados.rotina.registro_criancas" readonly />
                    </el-form-item>
                </el-form>
            </c-panel>
        </div>

        <!-- Pré-Escola -->
        <div v-else-if="tipo === 'pre_escola'">
            <c-panel title="Educação Infantil — Pré-Escola">
                <el-form label-position="top">
                    <el-form-item label="Objetivos de aprendizagem">
                        <el-input type="textarea" :value="dados.objetivos_aprendizagem" readonly />
                    </el-form-item>

                    <el-form-item label="Campos de experiência">
                        <el-checkbox-group :value="dados.campos_experiencia || []" disabled>
                            <el-checkbox v-for="opt in CAMPOS_EXPERIENCIA" :key="opt.key" :label="opt.key">{{ opt.label }}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                    <el-form-item label="Atividades prioritárias">
                        <el-checkbox-group :value="dados.atividades_prioritarias || []" disabled>
                            <el-checkbox v-for="opt in ATIVIDADES_PRIORITARIAS_PRE_ESCOLA" :key="opt.key" :label="opt.key">{{ opt.label }}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                    <h4 class="titulo-bloco">Momentos da rotina</h4>

                    <el-form-item label="Atividades de acolhimento">
                        <el-checkbox-group :value="dados.rotina && Array.isArray(dados.rotina.acolhimento) ? dados.rotina.acolhimento : []" disabled>
                            <el-checkbox v-for="opt in ATIVIDADES_ACOLHIMENTO_PRE_ESCOLA" :key="opt.key" :label="opt.key">{{ opt.label }}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                    <el-form-item label="Atividades permanentes">
                        <el-checkbox-group :value="dados.rotina && dados.rotina.permanentes || []" disabled>
                            <el-checkbox v-for="opt in ATIVIDADES_PERMANENTES_PRE_ESCOLA" :key="opt.key" :label="opt.key">{{ opt.label }}</el-checkbox>
                        </el-checkbox-group>
                        <el-input class="u-mt-10" type="textarea" :value="dados.rotina && dados.rotina.permanentes_obs" readonly placeholder="Observações" />
                    </el-form-item>

                    <el-form-item label="Letramento Matemático">
                        <el-checkbox-group :value="dados.rotina && dados.rotina.letramento_matematico || []" disabled>
                            <el-checkbox v-for="opt in LETRAMENTO_MATEMATICO_OPCOES" :key="opt.key" :label="opt.key">{{ opt.label }}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                    <el-form-item label="Atividades de leitura e/ou contação de histórias">
                        <el-input type="textarea" :value="dados.rotina && dados.rotina.leitura_contacao" readonly />
                    </el-form-item>

                    <el-form-item label="Brincadeiras">
                        <el-input type="textarea" :value="dados.rotina && dados.rotina.brincadeiras" readonly />
                    </el-form-item>

                    <el-form-item label="Musicalização">
                        <el-input type="textarea" :value="dados.rotina && dados.rotina.musicalizacao" readonly />
                    </el-form-item>

                    <el-form-item label="Atividade de projeto específico da Educação Infantil ou projeto didático">
                        <el-input type="textarea" :value="dados.rotina && dados.rotina.proleei" readonly />
                    </el-form-item>

                    <el-form-item label="Estratégias de inclusão e equidade (Adaptações, mediações, apoio individual, atenção às singularidades)">
                        <el-input type="textarea" :value="dados.rotina && dados.rotina.inclusao_equidade" readonly />
                    </el-form-item>

                    <el-form-item label="Atividades de Registro feito pelas crianças">
                        <el-input type="textarea" :value="dados.rotina && dados.rotina.registro_criancas" readonly />
                    </el-form-item>
                </el-form>
            </c-panel>
        </div>

        <!-- Anos Iniciais -->
        <div v-else-if="tipo === 'anos_iniciais'">
            <c-panel title="Anos Iniciais (1º ao 5º ano)">
                <el-form label-position="top">
                    <!-- <el-form-item label="Mês de referência">
                        <el-input :value="dados.cabecalho && dados.cabecalho.mes" readonly />
                    </el-form-item> -->

                    <h4 class="titulo-bloco">Habilidades e estratégias por componente curricular</h4>

                    <!-- Língua Portuguesa -->
                    <div class="bloco-componente">
                        <strong>Língua Portuguesa</strong>
                        <div class="u-mt-5">Práticas de Linguagem:</div>
                        <el-checkbox-group :value="dados.lingua_portuguesa && dados.lingua_portuguesa.praticas || []" disabled>
                            <el-checkbox v-for="opt in PRATICAS_LINGUAGEM" :key="opt.key" :label="opt.key">{{ opt.label }}</el-checkbox>
                        </el-checkbox-group>
                        <el-form-item label="Habilidades / Estratégias" class="u-mt-10">
                            <el-input type="textarea" :value="dados.lingua_portuguesa && dados.lingua_portuguesa.habilidades_estrategias" readonly />
                        </el-form-item>
                    </div>

                    <!-- Educação Física -->
                    <div class="bloco-componente">
                        <strong>Educação Física *(ABORDAGEM INTERDISCIPLINAR)</strong>
                        <el-form-item label="Habilidades / Estratégias" class="u-mt-10">
                            <el-input type="textarea" :value="dados.ed_fisica && dados.ed_fisica.habilidades_estrategias" readonly />
                        </el-form-item>
                    </div>

                    <!-- Arte -->
                    <div class="bloco-componente">
                        <strong>Arte *(ABORDAGEM INTERDISCIPLINAR)</strong>
                        <el-form-item label="Habilidades / Estratégias" class="u-mt-10">
                            <el-input type="textarea" :value="dados.arte && dados.arte.habilidades_estrategias" readonly />
                        </el-form-item>
                    </div>

                    <!-- Diversidade -->
                    <div class="bloco-componente">
                        <strong>Diversidade *(ABORDAGEM INTERDISCIPLINAR)</strong>
                        <el-form-item label="Habilidades / Estratégias" class="u-mt-10">
                            <el-input type="textarea" :value="dados.diversidade && dados.diversidade.habilidades_estrategias" readonly />
                        </el-form-item>
                    </div>

                    <!-- Matemática -->
                    <div class="bloco-componente">
                        <strong>Matemática</strong>
                        <div class="u-mt-5">Unidade Temática:</div>
                        <el-checkbox-group :value="dados.matematica && dados.matematica.unidades || []" disabled>
                            <el-checkbox v-for="opt in UNIDADES_TEMATICAS_MATEMATICA" :key="opt.key" :label="opt.key">{{ opt.label }}</el-checkbox>
                        </el-checkbox-group>
                        <el-form-item label="Habilidades / Estratégias" class="u-mt-10">
                            <el-input type="textarea" :value="dados.matematica && dados.matematica.habilidades_estrategias" readonly />
                        </el-form-item>
                    </div>

                    <!-- Ciências -->
                    <div class="bloco-componente">
                        <strong>Ciências</strong>
                        <div class="u-mt-5">Unidade Temática:</div>
                        <el-checkbox-group :value="dados.ciencias && dados.ciencias.unidades || []" disabled>
                            <el-checkbox v-for="opt in UNIDADES_TEMATICAS_CIENCIAS" :key="opt.key" :label="opt.key">{{ opt.label }}</el-checkbox>
                        </el-checkbox-group>
                        <el-form-item label="Habilidades / Estratégias" class="u-mt-10">
                            <el-input type="textarea" :value="dados.ciencias && dados.ciencias.habilidades_estrategias" readonly />
                        </el-form-item>
                    </div>

                    <!-- Geografia -->
                    <div class="bloco-componente">
                        <strong>Geografia</strong>
                        <div class="u-mt-5">Unidade Temática:</div>
                        <el-checkbox-group :value="dados.geografia && dados.geografia.unidades || []" disabled>
                            <el-checkbox v-for="opt in UNIDADES_TEMATICAS_GEOGRAFIA" :key="opt.key" :label="opt.key">{{ opt.label }}</el-checkbox>
                        </el-checkbox-group>
                        <el-form-item label="Habilidades / Estratégias" class="u-mt-10">
                            <el-input type="textarea" :value="dados.geografia && dados.geografia.habilidades_estrategias" readonly />
                        </el-form-item>
                    </div>

                    <!-- História -->
                    <div class="bloco-componente">
                        <strong>História</strong>
                        <div class="u-mt-5">Unidade Temática:</div>
                        <el-checkbox-group :value="dados.historia && dados.historia.unidades || []" disabled>
                            <el-checkbox v-for="opt in UNIDADES_TEMATICAS_HISTORIA" :key="opt.key" :label="opt.key">{{ opt.label }}</el-checkbox>
                        </el-checkbox-group>
                        <el-form-item label="Habilidades / Estratégias" class="u-mt-10">
                            <el-input type="textarea" :value="dados.historia && dados.historia.habilidades_estrategias" readonly />
                        </el-form-item>
                    </div>

                    <!-- BNCC Computação -->
                    <div class="bloco-componente">
                        <strong>BNCC Computação *(ABORDAGEM INTERDISCIPLINAR)</strong>
                        <el-form-item label="Habilidades / Estratégias" class="u-mt-10">
                            <el-input type="textarea" :value="dados.bncc_computacao && dados.bncc_computacao.habilidades_estrategias" readonly />
                        </el-form-item>
                    </div>

                    <h4 class="titulo-bloco u-mt-20">Rotina Semanal</h4>

                    <el-form-item label="Atividades de acolhida">
                        <el-input type="textarea" :value="dados.rotina && dados.rotina.acolhida" readonly />
                    </el-form-item>
                    <el-form-item label="Indicação de leitura sobre temas abordados na semana">
                        <el-input type="textarea" :value="dados.rotina && dados.rotina.indicacao_leitura" readonly />
                    </el-form-item>
                    <el-form-item label="Atividades de fluência de leitura">
                        <el-input type="textarea" :value="dados.rotina && dados.rotina.fluencia_leitura" readonly />
                    </el-form-item>
                    <el-form-item label="Material de apoio">
                        <el-input type="textarea" :value="dados.rotina && dados.rotina.material_apoio" readonly />
                    </el-form-item>
                    <el-form-item label="Atividades práticas aplicadas em cada componente curricular">
                        <el-input type="textarea" :value="dados.rotina && dados.rotina.atividades_praticas" readonly />
                    </el-form-item>

                    <h4 class="titulo-bloco u-mt-20">Avaliação</h4>

                    <el-checkbox-group :value="dados.avaliacao && dados.avaliacao.opcoes || []" disabled>
                        <el-checkbox v-for="opt in AVALIACAO_OPCOES_ANOS_INICIAIS" :key="opt.key" :label="opt.key">{{ opt.label }}</el-checkbox>
                    </el-checkbox-group>

                    <el-form-item label="Outros (especificar)" class="u-mt-10">
                        <el-input :value="dados.avaliacao && dados.avaliacao.outros" readonly />
                    </el-form-item>
                </el-form>
            </c-panel>
        </div>

        <!-- Anos Finais -->
        <div v-else-if="tipo === 'anos_finais'">
            <c-panel title="Anos Finais (6º ao 9º ano)">
                <el-form label-position="top">
                    <el-form-item label="Tema da aula">
                        <el-input type="textarea" :value="dados.tema_aula" readonly />
                    </el-form-item>

                    <el-form-item label="Habilidades BNCC">
                        <el-input type="textarea" :value="dados.habilidades_bncc" readonly />
                    </el-form-item>

                    <el-form-item label="Estratégias metodológicas">
                        <el-input type="textarea" :value="dados.estrategias_metodologicas" readonly />
                    </el-form-item>

                    <!-- <h4 class="titulo-bloco">Desenvolvimento das aulas</h4>

                    <el-table :data="aulasParaTabela" border stripe size="small" class="u-mt-10">
                        <el-table-column prop="etapa" label="Etapa" width="180" />
                        <el-table-column v-for="(_, i) in [0,1,2,3]" :key="i" :label="`Aula ${i + 1}`">
                            <template slot-scope="scope">
                                <el-input
                                    type="textarea"
                                    :value="getAulaValue(i, scope.row.key)"
                                    readonly
                                />
                            </template>
                        </el-table-column>
                    </el-table> -->

                    <el-form-item label="Recursos didáticos" class="u-mt-15">
                        <el-input type="textarea" :value="dados.recursos_didaticos" readonly />
                    </el-form-item>

                    <!-- <el-form-item label="Recomposição da aprendizagem">
                        <el-input type="textarea" :value="dados.recomposicao_aprendizagem" readonly />
                    </el-form-item> -->

                    <el-form-item label="Inclusão / Adaptação (estratégias diferenciadas)">
                        <el-input type="textarea" :value="dados.inclusao_adaptacao" readonly />
                    </el-form-item>

                    <el-form-item label="Verificação da aprendizagem">
                        <el-input type="textarea" :value="dados.verificacao_aprendizagem" readonly />
                    </el-form-item>

                    <!-- <el-form-item label="Recuperação paralela">
                        <el-input type="textarea" :value="dados.recuperacao_paralela" readonly />
                    </el-form-item> -->

                    <el-form-item label="Observações (avanços, dificuldades, intervenções)">
                        <el-input type="textarea" :value="dados.observacoes" readonly />
                    </el-form-item>
                </el-form>
            </c-panel>
        </div>

        <!-- EJA -->
        <div v-else-if="tipo === 'eja'">
            <c-panel title="EJA — Educação de Jovens e Adultos">
                <el-form label-position="top">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="16" :md="16">
                            <el-form-item label="Rotina / Aula da semana">
                                <el-input :value="dados.rotina_aula_semana" readonly />
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="Duração da aula (min)">
                                <el-input :value="dados.duracao_aula_min" readonly />
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-form-item label="Eixo temático trabalhado">
                        <el-checkbox-group :value="dados.eixos_tematicos || []" disabled>
                            <el-checkbox v-for="opt in EIXOS_EJA" :key="opt.key" :label="opt.key">{{ opt.label }}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                    <el-form-item label="Objetos de conhecimento (conteúdos)">
                        <el-input type="textarea" :value="dados.objetos_conhecimento" readonly />
                    </el-form-item>

                    <!-- <el-form-item label="Acolhida">
                        <el-input type="textarea" :value="dados.acolhida" readonly />
                    </el-form-item> -->

                    <!-- <el-form-item label="Contextualização do tema">
                        <el-input type="textarea" :value="dados.contextualizacao" readonly />
                    </el-form-item> -->

                    <el-form-item label="Habilidade(s) semanal">
                        <el-input type="textarea" :value="dados.habilidades_semanal" readonly />
                    </el-form-item>

                    <el-form-item label="Estratégia metodológica">
                        <el-input type="textarea" :value="dados.estrategia_metodologica" readonly />
                    </el-form-item>

                    <el-form-item label="Atividade de avaliação processual">
                        <el-input type="textarea" :value="dados.instrumento_avaliacao" readonly />
                    </el-form-item>
                    
                    <el-form-item label="Inclusão/Equidade/Adaptação">
                        <el-input type="textarea" :value="dados.adaptacoes_inclusao" readonly />
                    </el-form-item>

                    <!-- <h4 class="titulo-bloco">Encaminhamentos para a próxima semana</h4>
                    <el-form-item label="Ajustes no planejamento">
                        <el-input type="textarea" :value="dados.encaminhamentos" readonly />
                    </el-form-item> -->

                    <!-- <el-form-item label="Recuperação / Paralela">
                        <el-input type="textarea" :value="dados.recuperacao_paralela" readonly />
                    </el-form-item> -->

                    <el-form-item label="Observação">
                        <el-input type="textarea" :value="dados.observacao" readonly />
                    </el-form-item>

                    <!-- <el-form-item label="Material / recursos utilizados">
                        <el-checkbox-group :value="dados.material || []" disabled>
                            <el-checkbox v-for="opt in MATERIAL_EJA" :key="opt.key" :label="opt.key">{{ opt.label }}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                    <el-form-item label="Em caso de 'Outros', especifique" v-if="dados.material && dados.material.includes('outros')">
                        <el-input :value="dados.material_outros" readonly />
                    </el-form-item> -->
                </el-form>
            </c-panel>
        </div>

        <!-- Fallback original (seção por seção) -->
        <div v-else>
            <div v-for="(secao, idx) in secoes" :key="idx" class="secao-render">
                <h5 class="secao-titulo">{{ secao.titulo }}</h5>
                <div v-for="(campo, j) in secao.campos" :key="j" class="campo-render">
                    <div class="campo-label">{{ campo.label }}</div>
                    <div class="campo-valor">{{ formatValor(campo.valor) || '—' }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    PRATICAS_LINGUAGEM,
    UNIDADES_TEMATICAS_MATEMATICA,
    UNIDADES_TEMATICAS_CIENCIAS,
    UNIDADES_TEMATICAS_GEOGRAFIA,
    UNIDADES_TEMATICAS_HISTORIA,
    AVALIACAO_OPCOES_ANOS_INICIAIS,
    CAMPOS_EXPERIENCIA,
    ATIVIDADES_PRIORITARIAS_PRE_ESCOLA,
    ATIVIDADES_PRIORITARIAS_CRECHE,
    ATIVIDADES_PERMANENTES_PRE_ESCOLA,
    LETRAMENTO_MATEMATICO_OPCOES,
    EIXOS_EJA,
    MATERIAL_EJA,
    ATIVIDADES_ACOLHIMENTO_CRECHE,
    ATIVIDADES_PERMANENTES_CRECHE,
    ATIVIDADES_ACOLHIMENTO_PRE_ESCOLA,
    FUNCOES_COGNITIVAS_AEE,
    FUNCOES_MOTORAS_AEE,
    FUNCOES_SOCIAIS_AEE,
    FUNCOES_EMOCIONAIS_AEE,
    AVALIACAO_PROCESSUAL_AEE,
} from '@/shared/constants';

export default {
    props: {
        dados: { type: Object, default: () => ({}) },
        tipo: { type: String, required: true },
    },
    data: () => ({
        CAMPOS_EXPERIENCIA,
        ATIVIDADES_PRIORITARIAS_PRE_ESCOLA,
        ATIVIDADES_PRIORITARIAS_CRECHE,
        ATIVIDADES_PERMANENTES_PRE_ESCOLA,
        LETRAMENTO_MATEMATICO_OPCOES,
        PRATICAS_LINGUAGEM,
        UNIDADES_TEMATICAS_MATEMATICA,
        UNIDADES_TEMATICAS_CIENCIAS,
        UNIDADES_TEMATICAS_GEOGRAFIA,
        UNIDADES_TEMATICAS_HISTORIA,
        AVALIACAO_OPCOES_ANOS_INICIAIS,
        EIXOS_EJA,
        MATERIAL_EJA,
        ATIVIDADES_ACOLHIMENTO_CRECHE,
        ATIVIDADES_PERMANENTES_CRECHE,
        ATIVIDADES_ACOLHIMENTO_PRE_ESCOLA,
    }),
    computed: {
        aulasParaTabela() {
            return [
                { etapa: 'Problematização inicial', key: 'problematizacao' },
                { etapa: 'Desenvolvimento', key: 'desenvolvimento' },
                { etapa: 'Aplicação do conhecimento', key: 'aplicacao' },
            ];
        },
        secoes() {
            const d = this.dados || {};

            if (this.tipo === 'anos_iniciais') {
                return [
                    { titulo: 'Cabeçalho', campos: [
                        { label: 'Mês', valor: d.cabecalho && d.cabecalho.mes },
                    ]},
                    { titulo: 'Língua Portuguesa', campos: [
                        { label: 'Práticas de linguagem', valor: this.labelsFromKeys(d.lingua_portuguesa && d.lingua_portuguesa.praticas, PRATICAS_LINGUAGEM) },
                        { label: 'Habilidades / Estratégias', valor: d.lingua_portuguesa && d.lingua_portuguesa.habilidades_estrategias },
                    ]},
                    { titulo: 'Educação Física *(ABORDAGEM INTERDISCIPLINAR)', campos: [
                        { label: 'Habilidades / Estratégias', valor: d.ed_fisica && d.ed_fisica.habilidades_estrategias },
                    ]},
                    { titulo: 'Arte *(ABORDAGEM INTERDISCIPLINAR)', campos: [
                        { label: 'Habilidades / Estratégias', valor: d.arte && d.arte.habilidades_estrategias },
                    ]},
                    { titulo: 'Diversidade *(ABORDAGEM INTERDISCIPLINAR)', campos: [
                        { label: 'Habilidades / Estratégias', valor: d.diversidade && d.diversidade.habilidades_estrategias },
                    ]},
                    { titulo: 'Matemática', campos: [
                        { label: 'Unidades temáticas', valor: this.labelsFromKeys(d.matematica && d.matematica.unidades, UNIDADES_TEMATICAS_MATEMATICA) },
                        { label: 'Habilidades / Estratégias', valor: d.matematica && d.matematica.habilidades_estrategias },
                    ]},
                    { titulo: 'Ciências', campos: [
                        { label: 'Unidades temáticas', valor: this.labelsFromKeys(d.ciencias && d.ciencias.unidades, UNIDADES_TEMATICAS_CIENCIAS) },
                        { label: 'Habilidades / Estratégias', valor: d.ciencias && d.ciencias.habilidades_estrategias },
                    ]},
                    { titulo: 'Geografia', campos: [
                        { label: 'Unidades temáticas', valor: this.labelsFromKeys(d.geografia && d.geografia.unidades, UNIDADES_TEMATICAS_GEOGRAFIA) },
                        { label: 'Habilidades / Estratégias', valor: d.geografia && d.geografia.habilidades_estrategias },
                    ]},
                    { titulo: 'História', campos: [
                        { label: 'Unidades temáticas', valor: this.labelsFromKeys(d.historia && d.historia.unidades, UNIDADES_TEMATICAS_HISTORIA) },
                        { label: 'Habilidades / Estratégias', valor: d.historia && d.historia.habilidades_estrategias },
                    ]},
                    { titulo: 'BNCC Computação *(ABORDAGEM INTERDISCIPLINAR)', campos: [
                        { label: 'Habilidades / Estratégias', valor: d.bncc_computacao && d.bncc_computacao.habilidades_estrategias },
                    ]},
                    { titulo: 'Rotina semanal', campos: [
                        { label: 'Atividades de acolhida', valor: d.rotina && d.rotina.acolhida },
                        { label: 'Indicação de leitura', valor: d.rotina && d.rotina.indicacao_leitura },
                        { label: 'Fluência de leitura', valor: d.rotina && d.rotina.fluencia_leitura },
                        { label: 'Material de apoio', valor: d.rotina && d.rotina.material_apoio },
                        { label: 'Atividades práticas', valor: d.rotina && d.rotina.atividades_praticas },
                    ]},
                    { titulo: 'Avaliação', campos: [
                        { label: 'Opções', valor: this.labelsFromKeys(d.avaliacao && d.avaliacao.opcoes, AVALIACAO_OPCOES_ANOS_INICIAIS) },
                        { label: 'Outros', valor: d.avaliacao && d.avaliacao.outros },
                    ]},
                ];
            }

            if (this.tipo === 'anos_finais') {
                const aulasCampos = (d.aulas || []).map((a, i) => ({
                    label: `Aula ${i + 1}`,
                    valor: `Problematização: ${a.problematizacao || '—'}\nDesenvolvimento: ${a.desenvolvimento || '—'}\nAplicação: ${a.aplicacao || '—'}`,
                }));

                return [
                    { titulo: 'Aula', campos: [
                        { label: 'Tema da aula', valor: d.tema_aula },
                        { label: 'Habilidades BNCC', valor: d.habilidades_bncc },
                        { label: 'Estratégias metodológicas', valor: d.estrategias_metodologicas },
                    ]},
                    { titulo: 'Desenvolvimento das aulas', campos: aulasCampos },
                    { titulo: 'Recursos e avaliação', campos: [
                        { label: 'Recursos didáticos', valor: d.recursos_didaticos },
                        { label: 'Recomposição da aprendizagem', valor: d.recomposicao_aprendizagem },
                        { label: 'Inclusão / Adaptacao', valor: d.inclusao_adaptacao },
                        { label: 'Avaliação da aprendizagem', valor: d.avaliacao_aprendizagem },
                        { label: 'Recuperação paralela', valor: d.recuperacao_paralela },
                        { label: 'Observações', valor: d.observacoes },
                    ]},
                ];
            }

            if (this.tipo === 'pre_escola') {
                return [
                    { titulo: 'Plano de atividade', campos: [
                        { label: 'Objetivos de aprendizagem', valor: d.objetivos_aprendizagem },
                        { label: 'Campos de experiência', valor: this.labelsFromKeys(d.campos_experiencia, CAMPOS_EXPERIENCIA) },
                        { label: 'Atividades prioritárias', valor: this.labelsFromKeys(d.atividades_prioritarias, ATIVIDADES_PRIORITARIAS_PRE_ESCOLA) },
                    ]},
                    { titulo: 'Momentos da rotina', campos: [
                        { label: 'Acolhimento', valor: d.rotina && Array.isArray(d.rotina.acolhimento) ? this.labelsFromKeys(d.rotina.acolhimento, ATIVIDADES_ACOLHIMENTO_PRE_ESCOLA) : (d.rotina ? d.rotina.acolhimento : '') },
                        { label: 'Atividades permanentes', valor: this.labelsFromKeys(d.rotina && d.rotina.permanentes, ATIVIDADES_PERMANENTES_PRE_ESCOLA) },
                        { label: 'Observações (atividades permanentes)', valor: d.rotina && d.rotina.permanentes_obs },
                        { label: 'Letramento Matemático', valor: this.labelsFromKeys(d.rotina && d.rotina.letramento_matematico, LETRAMENTO_MATEMATICO_OPCOES) },
                        { label: 'Leitura / Contação', valor: d.rotina && d.rotina.leitura_contacao },
                        { label: 'Brincadeiras', valor: d.rotina && d.rotina.brincadeiras },
                        { label: 'Musicalização', valor: d.rotina && d.rotina.musicalizacao },
                        { label: 'Atividade de projeto específico da Educação Infantil ou projeto didático', valor: d.rotina && d.rotina.proleei },
                        { label: 'Inclusão e equidade', valor: d.rotina && d.rotina.inclusao_equidade },
                        { label: 'Registro feito pelas crianças', valor: d.rotina && d.rotina.registro_criancas },
                    ]},
                ];
            }

            if (this.tipo === 'creche') {
                return [
                    { titulo: 'Plano de atividade', campos: [
                        { label: 'Objetivos de aprendizagem', valor: d.objetivos_aprendizagem },
                        { label: 'Campos de experiência', valor: this.labelsFromKeys(d.campos_experiencia, CAMPOS_EXPERIENCIA) },
                        { label: 'Atividades prioritárias', valor: this.labelsFromKeys(d.atividades_prioritarias, ATIVIDADES_PRIORITARIAS_CRECHE) },
                    ]},
                    { titulo: 'Momentos da rotina', campos: [
                        { label: 'Acolhimento', valor: d.rotina && Array.isArray(d.rotina.acolhimento) ? this.labelsFromKeys(d.rotina.acolhimento, ATIVIDADES_ACOLHIMENTO_CRECHE) : (d.rotina ? d.rotina.acolhimento : '') },
                        ...(d.rotina && Array.isArray(d.rotina.acolhimento) && d.rotina.acolhimento.includes('outra') && d.rotina.acolhimento_outra ? [{ label: 'Outra (Acolhimento)', valor: d.rotina.acolhimento_outra }] : []),
                        { label: 'Atividades permanentes', valor: d.rotina && Array.isArray(d.rotina.permanentes) ? this.labelsFromKeys(d.rotina.permanentes, ATIVIDADES_PERMANENTES_CRECHE) : (d.rotina ? d.rotina.permanentes : '') },
                        ...(d.rotina && Array.isArray(d.rotina.permanentes) && d.rotina.permanentes.includes('outra') && d.rotina.permanentes_outra ? [{ label: 'Outra (Atividades permanentes)', valor: d.rotina.permanentes_outra }] : []),
                        { label: 'Leitura / Contação', valor: d.rotina && d.rotina.leitura_contacao },
                        { label: 'Brincadeiras', valor: d.rotina && d.rotina.brincadeiras },
                        { label: 'Musicalização', valor: d.rotina && d.rotina.musicalizacao },
                        { label: 'Atividade de projeto específico da Educação Infantil ou projeto didático', valor: d.rotina && d.rotina.set_brasil },
                        { label: 'Inclusão e equidade', valor: d.rotina && d.rotina.inclusao_equidade },
                        { label: 'Registro feito pelas crianças', valor: d.rotina && d.rotina.registro_criancas },
                    ]},
                ];
            }

            if (this.tipo === 'eja') {
                return [
                    { titulo: 'Plano de aula EJA', campos: [
                        { label: 'Rotina / Aula da semana', valor: d.rotina_aula_semana },
                        { label: 'Duração da aula (min)', valor: d.duracao_aula_min },
                        { label: 'Eixos temáticos', valor: this.labelsFromKeys(d.eixos_tematicos, EIXOS_EJA) },
                        { label: 'Objetos de conhecimento', valor: d.objetos_conhecimento },
                        // { label: 'Acolhida', valor: d.acolhida },
                        // { label: 'Contextualização', valor: d.contextualizacao },
                        { label: 'Habilidades semanais', valor: d.habilidades_semanal },
                        { label: 'Estratégia metodológica', valor: d.estrategia_metodologica || d.desenvolvimento },
                        { label: 'Atividade de avaliação processual', valor: d.instrumento_avaliacao },
                        { label: 'Inclusão/Equidade/Adaptação', valor: d.adaptacoes_inclusao },
                        // { label: 'Encaminhamentos', valor: d.encaminhamentos },
                        // { label: 'Recuperação paralela', valor: d.recuperacao_paralela },
                        { label: 'Observação', valor: d.observacao },
                        // { label: 'Material', valor: this.labelsFromKeys(d.material, MATERIAL_EJA) },
                        // { label: 'Material — Outros', valor: d.material_outros },
                    ]},
                ];
            }

            if (this.tipo === 'aee') {
                const fe = d.funcoes_estrategias || {};
                const camposFuncoes = [];

                if (fe.cognitiva && fe.cognitiva.length) {
                    let labelVal = this.labelsFromKeys(fe.cognitiva, FUNCOES_COGNITIVAS_AEE);
                    if (fe.cognitiva.includes('outros') && fe.cognitiva_outros) {
                        labelVal += ` (${fe.cognitiva_outros})`;
                    }
                    camposFuncoes.push({ label: 'Função Cognitiva', valor: labelVal });
                }
                if (fe.motora && fe.motora.length) {
                    let labelVal = this.labelsFromKeys(fe.motora, FUNCOES_MOTORAS_AEE);
                    if (fe.motora.includes('outros') && fe.motora_outros) {
                        labelVal += ` (${fe.motora_outros})`;
                    }
                    camposFuncoes.push({ label: 'Função Motora', valor: labelVal });
                }
                if (fe.social && fe.social.length) {
                    let labelVal = this.labelsFromKeys(fe.social, FUNCOES_SOCIAIS_AEE);
                    if (fe.social.includes('outros') && fe.social_outros) {
                        labelVal += ` (${fe.social_outros})`;
                    }
                    camposFuncoes.push({ label: 'Função Social', valor: labelVal });
                }
                if (fe.emocional && fe.emocional.length) {
                    let labelVal = this.labelsFromKeys(fe.emocional, FUNCOES_EMOCIONAIS_AEE);
                    if (fe.emocional.includes('outros') && fe.emocional_outros) {
                        labelVal += ` (${fe.emocional_outros})`;
                    }
                    camposFuncoes.push({ label: 'Função Emocional', valor: labelVal });
                }
                if (fe.habilidades_recursos_estrategias) {
                    camposFuncoes.push({ label: 'Habilidades / Recursos / Estratégias', valor: fe.habilidades_recursos_estrategias });
                }

                let avaliacaoVal = this.labelsFromKeys(d.avaliacao_processual, AVALIACAO_PROCESSUAL_AEE);
                if (d.avaliacao_processual && d.avaliacao_processual.includes('outros') && d.avaliacao_processual_outros) {
                    avaliacaoVal += ` (${d.avaliacao_processual_outros})`;
                }

                return [
                    { titulo: 'Funções e Estratégias da Semana', campos: camposFuncoes },                    
                    { titulo: 'Avaliação Processual e Contínua', campos: [
                        { label: 'Estratégias / Encaminhamentos', valor: avaliacaoVal }
                    ]}
                ];
            }

            return [{ titulo: 'Dados', campos: [{ label: 'JSON', valor: JSON.stringify(d, null, 2) }] }];
        }
    },
    methods: {
        getAulaValue(i, key) {
            const aulas = this.dados.aulas || [];
            const aula = aulas[i] || {};
            return aula[key] || '';
        },
        labelsFromKeys(keys, dictArray) {
            if (!Array.isArray(keys) || keys.length === 0) return '';
            const map = {};
            dictArray.forEach(o => { map[o.key] = o.label; });
            return keys.map(k => map[k] || k).join(', ');
        },
        formatValor(v) {
            if (v === null || v === undefined) return '';
            if (Array.isArray(v)) return v.join(', ');
            if (typeof v === 'object') return JSON.stringify(v, null, 2);
            return String(v);
        }
    }
}
</script>
<style scoped>
.secao-render {
    margin-bottom: 20px;
    padding: 12px;
    background-color: #fafafa;
    border-left: 3px solid #1976d2;
}
.secao-titulo {
    color: #1976d2;
    margin: 0 0 10px 0;
}
.campo-render {
    margin-bottom: 10px;
}
.campo-label {
    font-weight: 600;
    color: #555;
    font-size: 0.9em;
}
.campo-valor {
    white-space: pre-wrap;
    margin-top: 2px;
}
.titulo-bloco {
    margin-top: 20px;
    color: #1976d2;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 5px;
}
.bloco-componente {
    margin-top: 15px;
    padding: 12px;
    background-color: #fafafa;
    border-left: 3px solid #1976d2;
}
</style>
